<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 256 256"
  [attr.width]="size"
  [attr.height]="size"
>
  <g transform="scale(5.33333,5.33333)">
    <path
      class="parte-colorida"
      [attr.fill]="color"
      d="M44,24c0,11.045 -8.955,20 -20,20c-11.045,0 -20,-8.955 -20,-20c0,-11.045 8.955,-20 20,-20c11.045,0 20,8.955 20,20z"
    ></path>

    <path d="M21,14h6v20h-6z" [attr.fill]="'#fff'"></path>
    <path d="M14,21h20v6h-20z" [attr.fill]="'#fff'"></path>
  </g>
</svg>
